import script from "./Business.vue?vue&type=script&setup=true&lang=js"
export * from "./Business.vue?vue&type=script&setup=true&lang=js"

import "./Business.vue?vue&type=style&index=0&id=18d94bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18d94bb0"]])

export default __exports__